import { render, staticRenderFns } from "./IncomeOtherPersonHouseholdFS.vue?vue&type=template&id=71a8332b&scoped=true"
import script from "./IncomeOtherPersonHouseholdFS.vue?vue&type=script&lang=ts"
export * from "./IncomeOtherPersonHouseholdFS.vue?vue&type=script&lang=ts"
import style0 from "./IncomeOtherPersonHouseholdFS.vue?vue&type=style&index=0&id=71a8332b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8332b",
  null
  
)

export default component.exports